import { ReactNode } from 'react';
import HeroImage from '../CheckoutHero.avif';

/**
 * @description Checkout page layout for the control group: hero banner above the checkout panel.
 */
export const CheckoutControlLayout = ({
  firstName,
  children,
}: {
  firstName?: string;
  children: ReactNode;
}) => {
  const { VITE_CLIENT_FRIENDLY_NAME } = import.meta.env;

  return (
    <div className="bg-neutral-100">
      <div className="relative w-full h-50 overflow-hidden">
        <img
          src={HeroImage}
          alt=""
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-360 h-auto max-w-none"
        />
        <div className="absolute inset-0 flex items-center justify-center p-5">
          <div className="bg-bg-main-container p-6 rounded max-w-205 text-center">
            <h1 className="text-h3">
              {firstName}, let's set up your {VITE_CLIENT_FRIENDLY_NAME} appliance care
            </h1>
          </div>
        </div>
      </div>
      <div className="col-span-full">
        <div className="pt-10 pb-6 min-h-375 bg-neutral-100">{children}</div>
      </div>
    </div>
  );
};
